import {Component, inject, OnInit} from '@angular/core';
import {GrpcAuthorizationOPEService} from "../../services/ope/grpc/authorizationOPE.service";
import {GlobalModelService} from "../../services/GlobalModel.service";

interface ImpersonationClaims {
  sub?: string;
  email?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
}

@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.css']
})
export class ImpersonationBannerComponent implements OnInit {

  private authorizationService = inject(GrpcAuthorizationOPEService);
  private readonly gmService: GlobalModelService = inject(GlobalModelService);
  protected isImpersonating = false;
  protected displayName = '';
  protected displayEmail = '';

  ngOnInit(): void {
    const token = sessionStorage.getItem('impersonationToken');
    if (!token) return;

    this.isImpersonating = true;
    try {
      this.displayName = this.gmService.user.firstname + ' ' + this.gmService.user.lastname;
      this.displayEmail = this.gmService.user.email;
    } catch {
      // malformed token — banner still shows, names stay empty
    }
  }

  protected stopImpersonation(): void {
    this.authorizationService.stopImpersonation();
    window.location.href = '/';
  }
}
